import Model, { executeMutation, GqlError, ID } from 'src/models/model'

/**
 * This model is used solely in Admin developer settings UI to toggle feature flags.
 * Feature flag checks at runtime should instead be done through clientContext.isFeatureEnabled().
 */
export default class FeatureFlag extends Model {
  static name = 'FeatureFlag'

  static paginate = true

  static define () {
    this.fields = {
      key: {
        type: String,
        output: true
      },
      toggleableClassNames: {
        type: [String],
        output: true
      },
      togglesSummary: {
        type: String,
        output: true
      },
      togglesCount: {
        type: Number,
        output: true
      },
      currentRegionEnabled: {
        type: Boolean,
        output: true
      },
      currentCircuitEnabled: {
        type: Boolean,
        output: true
      },
      currentCircuitEnabledDirectly: {
        type: Boolean,
        output: true
      },
      currentSiteEnabled: {
        type: Boolean,
        output: true
      },
      currentSiteEnabledDirectly: {
        type: Boolean,
        output: true
      }
    }

    this.mutations = {
      enableFeatureFlagForRegion: {
        arguments: {
          key: {
            type: String,
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      },
      enableFeatureFlagForModel: {
        arguments: {
          key: {
            type: String,
            required: true
          },
          flaggableType: {
            type: String,
            required: true
          },
          flaggableId: {
            type: ID,
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      },
      disableFeatureFlagForRegion: {
        arguments: {
          key: {
            type: String,
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      },
      disableFeatureFlagForModel: {
        arguments: {
          key: {
            type: String,
            required: true
          },
          flaggableType: {
            type: String,
            required: true
          },
          flaggableId: {
            type: ID,
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      }
    }
  }

  static enableFeatureFlagForRegion (key) {
    return executeMutation(
      'enableFeatureFlagForRegion',
      { key },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  static enableFeatureFlagForModel (key, flaggableType, flaggableId) {
    return executeMutation(
      'enableFeatureFlagForModel',
      { key, flaggableType, flaggableId },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  enableForRegion () {
    return this.constructor.enableFeatureFlagForRegion(this.key)
  }

  enableForModel (flaggableType, flaggableId) {
    return this.constructor.enableFeatureFlagForModel(this.key, flaggableType, flaggableId)
  }

  static disableFeatureFlagForRegion (key) {
    return executeMutation(
      'disableFeatureFlagForRegion',
      { key },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  static disableFeatureFlagForModel (key, flaggableType, flaggableId) {
    return executeMutation(
      'disableFeatureFlagForModel',
      { key, flaggableType, flaggableId },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true,
            backtrace: true
          }
        }
      }
    )
  }

  disableForRegion () {
    return this.constructor.disableFeatureFlagForRegion(this.key)
  }

  disableForModel (flaggableType, flaggableId) {
    return this.constructor.disableFeatureFlagForModel(this.key, flaggableType, flaggableId)
  }
}
